"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFocusableChildren = exports.getBreakpoint = void 0;
/**
 * Get current breakpoint.
 *
 * @returns {String} 2-letter code.
 */
function getBreakpoint() {
    let breakpoint = 'lg';
    const breakpoints = [
        { id: 'xs', width: 672 },
        { id: 'sm', width: 1056 },
        { id: 'md', width: 1312 },
    ];
    for (let i = 0; i < breakpoints.length; i++) {
        const item = breakpoints[i];
        if (window.innerWidth < item.width) {
            breakpoint = item.id;
            break;
        }
    }
    return breakpoint;
}
exports.getBreakpoint = getBreakpoint;
/**
 * Get focusable children for given element.
 *
 * @param {Element|null} [element] Container to check. If empty, fetches all elements from current document.
 * @param {object} [options] Options to specify what rules are checked.
 * @param {boolean} [checkHidden] Whether elements with hidden attribute are excluded. Default is true.
 * @param {boolean} [checkDisabled] Whether elements with disabled attribute are excluded. Default is true.
 * @param {boolean} [checkTabIndex] Whether elements with negative tabindex are excluded. Default is true.
 * @param {boolean} [checkVisibility] Whether non-visible elements are excluded. Default is true.
 * @returns {Element[]} Array of focusable elements.
 */
function getFocusableChildren(element = null, options = {}) {
    const selectors = [
        'a[href]',
        'area[href]',
        'input:not([type="hidden"]):not([type="radio"])',
        'input[type="radio"]:checked',
        'select',
        'textarea',
        'button',
        'iframe',
        'audio[controls]',
        'video[controls]',
        '[contenteditable]',
        '[tabindex]:not([tabindex^="-"])',
        '[role="button"]'
    ];
    const container = element || window.document;
    const focusOptions = {
        checkHidden: true,
        checkDisabled: true,
        checkTabIndex: true,
        checkVisibility: true,
        ...options
    };
    return Array.from(container.querySelectorAll(selectors.join(','))).filter((child) => {
        if (focusOptions.checkHidden && child.hidden) {
            return false;
        }
        if (focusOptions.checkDisabled && child.disabled) {
            return false;
        }
        if (focusOptions.checkTabIndex && String(child.tabindex).indexOf('-') === 0) {
            return false;
        }
        if (focusOptions.checkVisibility && (!child.offsetWidth || !child.offsetHeight || !child.getClientRects().length)) {
            return false;
        }
        return true;
    });
}
exports.getFocusableChildren = getFocusableChildren;
